export default __webpack_public_path__ + "5dff1ff824a00af6d28b230f553063b4.png";